import { render, staticRenderFns } from "./cartDialog.vue?vue&type=template&id=cd874c00&"
import script from "./cartDialog.vue?vue&type=script&lang=js&"
export * from "./cartDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports